import { useEffect } from "react";
import { useToolbarMetricsStore } from "./useToolbarMetricsStore";
export var useToolbarTimer = function (collapsed) {
    var _a = useToolbarMetricsStore(), addCollapsedDuration = _a.addCollapsedDuration, lastCollapsedTimestamp = _a.lastCollapsedTimestamp, setLastCollapsedTimestamp = _a.setLastCollapsedTimestamp;
    useEffect(function () {
        if (collapsed) {
            var collapseTimestamp = performance.now();
            setLastCollapsedTimestamp(collapseTimestamp);
        }
        else {
            var expandTimestamp = performance.now();
            if (lastCollapsedTimestamp !== undefined) {
                addCollapsedDuration((expandTimestamp - lastCollapsedTimestamp) / 1000);
            }
        }
    }, [collapsed]);
};
